import React, { useEffect } from "react";

export default function DarkModeToggle({ isDarkMode, setIsDarkMode }) {
  // Track whether Dark Mode is currently enabled

  // On component mount, check if user had a preferred theme previously
  // (if you want to store preference in localStorage):
  // useEffect(() => {
  //   const storedTheme = localStorage.getItem('theme');
  //   if (storedTheme === 'dark') {
  //     setIsDarkMode(true);
  //   }
  // }, []);

  // Whenever isDarkMode changes, toggle the `dark` class on <html>
  useEffect(() => {
    const root = window.document.documentElement;
    if (isDarkMode) {
      root.classList.add("dark");
      // localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove("dark");
      // localStorage.setItem('theme', 'light');
    }
  }, [isDarkMode]);

  // Toggle handler
  const handleToggle = () => {
    setIsDarkMode((prev) => !prev);
  };

  return (
    <label className="relative inline-flex items-center cursor-pointer">
      <input
        type="checkbox"
        checked={isDarkMode}
        onChange={handleToggle}
        className="sr-only peer" // Hide the default checkbox visually
      />
      {/* The slider background */}
      <div
        className="w-14 h-7 bg-gray-300 peer-focus:outline-none dark:bg-gray-600 
                      peer-checked:bg-gray-600 rounded-full peer peer-checked:after:translate-x-7
                      after:content-[''] after:absolute after:top-0.5 after:left-[2px] 
                      after:bg-white after:border-gray-300 after:border after:rounded-full 
                      after:h-6 after:w-6 after:transition-all 
                      dark:peer-focus:ring-gray-800
                      relative"
      />
      {/* The label text */}
      <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">
        {isDarkMode ? "Dark Mode" : "Light Mode"}
      </span>
    </label>
  );
}
